export const ButtonStyle = {
  borderRadius: 0,
  bgColor: "black",
  color: "white",
  fontWeight: "bold",
  _hover: { bgColor: "none" },
};

export const baseURL = "https://comfortable-swimsuit-dog.cyclic.app/";
